var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFirstAidKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8 6C34.1278 6.00265 36.3595 6.92853 38.0055 8.57453C39.6515 10.2205 40.5774 12.4522 40.58 14.78V14.78V16.48H48.4C48.8244 16.48 49.2313 16.6486 49.5314 16.9486C49.8314 17.2487 50 17.6557 50 18.08V18.08V45.08C50 45.5043 49.8314 45.9113 49.5314 46.2114C49.2313 46.5114 48.8244 46.68 48.4 46.68H7.6C7.38819 46.68 7.17849 46.638 6.98305 46.5563C6.78762 46.4747 6.61034 46.355 6.4615 46.2043C6.31266 46.0536 6.19523 45.8749 6.11601 45.6784C6.03679 45.482 5.99736 45.2718 6 45.06V18.06C6 17.6357 6.16857 17.2287 6.46863 16.9286C6.76869 16.6286 7.17566 16.46 7.6 16.46H15.42V14.76C15.4279 12.4357 16.3561 10.2091 18.0016 8.56744C19.647 6.92577 21.8757 6.00263 24.2 6H31.8V6ZM31 21.75H25V28.75H18V34.75H25V41.75H31V34.75H38V28.75H31V21.75ZM31.8 10.6H24.2C23.6494 10.5974 23.1037 10.7035 22.5942 10.9124C22.0848 11.1213 21.6216 11.4288 21.2314 11.8172C20.8411 12.2056 20.5314 12.6673 20.3201 13.1758C20.1088 13.6842 20 14.2294 20 14.78V14.78V16.48H36V14.78C36 14.2294 35.8912 13.6842 35.6799 13.1758C35.4686 12.6673 35.1589 12.2056 34.7686 11.8172C34.3784 11.4288 33.9152 11.1213 33.4058 10.9124C32.8963 10.7035 32.3506 10.5974 31.8 10.6V10.6Z",
    fill: "#0A0D0D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidKit);
export default __webpack_public_path__ + "static/media/first-aid-kit.03fc2e88.svg";
export { ForwardRef as ReactComponent };